import { useState } from "react";
import DeleteIcon from "@mui/icons-material/Delete";
import { CustomSearch } from "../../../component/CustomSearch";
import { SideDrawer } from "../../../component/SideDrawer/SideDrawer";
import InvoiceInput from "../../../component/InventoryUI/InvoiceInput";
import { calculateInvoiceTotalsWithGST } from "../../../utils/utils";
import { useSnackbar } from "../../../context/SnackBarContext";
import CrmTable from "../../../component/CrmTable";
import { useGetCrmProduct } from "../../../hooks/cmsInvoice";
import { useNavigate } from "react-router-dom";
import { useCrm } from "../../../context/CrmContext";

const CrmInvoiceUI = ({ state, updateFunc, setTableData, tableData, setBillingData, formData }) => {
  const { product: productsName, params, setParams } = useGetCrmProduct()
  const [drawerOpen, setDrawerOpen] = useState(false);
  const { showSuccess, showError } = useSnackbar();
  const [row, setRow] = useState(0)
  const navigate = useNavigate()
  const { user } = useCrm()
  const toggleDrawer = () => {
    setDrawerOpen(!drawerOpen);
  };

  const handleOptions = (rowId) => {
    setTableData((prevData) => {
      if (prevData.length > 1) {
        return prevData.filter((item) => item.id !== rowId);
      } else {
        return prevData;
      }
    });
  };

  const handleInputChange = (id, field, value) => {

    setTableData((prevData) => {
      const updatedData = prevData.map((item) => {
        if (item.id === id) {
          const updatedItem = { ...item, [field]: value };
          if (["quantity", "price", "discount", "tax", "cgst", "sgst", "igst"].includes(field)) {
            const qty = parseFloat(updatedItem.quantity) || 0;
            const price = parseFloat(updatedItem.price) || 0;
            const discountRate = parseFloat(updatedItem.discount) || 0;
            const cgst = parseFloat(updatedItem.cgst) || 0;
            const sgst = parseFloat(updatedItem.sgst) || 0;
            const igst = parseFloat(updatedItem.igst) || 0;

            const itemTotal = qty * price;
            const discountAmount = (discountRate / 100) * itemTotal;
            const taxableAmount = itemTotal - discountAmount;

            // Calculate amount with GST
            updatedItem.amount = (taxableAmount +
              (taxableAmount * cgst) / 100 +
              (taxableAmount * sgst) / 100 +
              (taxableAmount * igst) / 100).toFixed(2);
          }

          return updatedItem;
        }
        return item;
      });

      setBillingData(calculateInvoiceTotalsWithGST(updatedData, user?.state, formData?.state));
      return updatedData;
    });
  };


  const transformedData = tableData.map((item, index) => ({
    product: {
      value: (<div
        onClick={() => { updateFunc({ isProductDrawerOpen: true }); setRow(index) }}
        className={`cursor-pointer bg-red-100`}
        style={{
          height: "100%",
          minHeight: "1.5rem",
        }}>
        {item.product && <span>{item.product}</span>}
      </div>),
      type: "custom",
    },
    productCode: {
      value: item.productCode,
      type: "custom",
    },
    quantity: {
      value: (
        <InvoiceInput
          value={item.quantity}
          placeholder="0.00"
          onChange={(e) => handleInputChange(item.id, "quantity", e.target.value)}
        />
      ),
      type: "custom",
    },
    unit: {
      value: (
        <InvoiceInput
          value={item.unit}
          placeholder=""
          onChange={(e) => handleInputChange(item.id, "unit", e.target.value)}
        />
      ),
      type: "custom",
    },
    price: {
      value: (
        <InvoiceInput
          value={item.price}
          icon={true}
          placeholder="0.00"
          onChange={(e) => handleInputChange(item.id, "price", e.target.value)}
        />
      ),
      type: "custom",
    },
    discount: {
      value: (
        <InvoiceInput
          value={item.discount}
          placeholder="0.00"
          onChange={(e) => handleInputChange(item.id, "discount", e.target.value)}
        />
      ),
      type: "custom",
    },

    igst: {
      value:
        formData.withGST && user?.state !== formData?.state ? (
          <InvoiceInput
            value={item.igst}
            placeholder="0.00"
            onChange={(e) => handleInputChange(item.id, "igst", e.target.value)}
          />
        ) : (
          <span>-</span>
        ),
      type: "custom",
    },
    cgst: {
      value:
        formData.withGST && user?.state === formData?.state ? (
          <InvoiceInput
            value={item.cgst}
            placeholder="0.00"
            onChange={(e) => handleInputChange(item.id, "cgst", e.target.value)}
          />
        ) : (
          <span>-</span>
        ),
      type: "custom",
    },
    sgst: {
      value:
        formData.withGST && user?.state === formData?.state ? (
          <InvoiceInput
            value={item.sgst}
            placeholder="0.00"
            onChange={(e) => handleInputChange(item.id, "sgst", e.target.value)}
          />
        ) : (
          <span>-</span>
        ),
      type: "custom",
    },


    amount: {
      value: (
        <InvoiceInput
          value={item.amount}
          icon={true}
          placeholder="0.00"
          onChange={(e) => handleInputChange(item.id, "amount", e.target.value)}
        />
      ),
      type: "custom",
    },
    Action: {
      value: (
        <DeleteIcon
          className="cursor-pointer text-red-600"
          onClick={() => handleOptions(item.id)}
        />
      ),
      type: "custom",
    },


  }));

  const columns = [
    "Product",
    "HSX Code",
    "Quantity ",
    "Unit",
    "Price/Unit",
    "Discount(%)",
    "IGST(%)",
    "CGST(%)",
    "SGST(%)",
    "Amount",
    "Action",
  ];

  const handleAddItem = () => {
    const newRow = {
      id: tableData.length + 1,
      product: "",
      productCode: "",
      quantity: "",
      availableQty: "",
      unit: "",
      price: "",
      discount: "",
      cgst: "",
      sgst: "",
      igst: "",
      amount: "",
      productId: "",
      product_image: "",
    };
    setTableData((prevData) => [...prevData, newRow]);
  };


  const handleClearAllItems = () => {
    setTableData([]);
  };

  const handleSelectedProduct = (item) => {
    setTableData((prevData) => {
      const isProductCodeExists = prevData.some(
        (rowData) => rowData.productCode == item.productCode
      );

      if (isProductCodeExists) {
        showError("This Product Already Selected Plz Select Other")
        return prevData;
      }

      return prevData.map((rowData, index) =>
        index === row
          ? {
            ...rowData,
            productId: item._id || item.id || "",
            product: item.productName,
            productCode: item.productCode || "",
            number: item.number || "",
            price: item.price || '',
            availableQty: item.availableQty || '',
            product_image: item.product_image,
          }
          : rowData
      )
    })
    updateFunc({ isProductDrawerOpen: false });
  };

  const handleAddProduct = () => {
    updateFunc({ isProductDrawerOpen: false })
    toggleDrawer()
    navigate("/crm/manage-product")
  }

  return (
    <div className="md:px-5 px-2">
      <div className="">
        <CrmTable
          data={transformedData}
          columns={columns}
          checkbox={false}
          defaultRowSelected={[0]}
        />
      </div>
      <div className="flex md:flex-row flex-wrap items-center justify-between space-x-4 mb-4 mt-4">
        {/* Top Section */}
        <div className="flex md:flex-row flex-wrap items-center space-x-4 mb-4">
          <button
            className="text-[#0a3021] font-medium hover:underline"
            onClick={handleAddItem}
          >
            + Add Item
          </button>
          <button
            className="text-red-600 font-medium hover:underline"
            onClick={handleClearAllItems}
          >
            - Clear all items
          </button>
        </div>
      </div>

      <SideDrawer open={state.isProductDrawerOpen}
        onClose={() => updateFunc({ isProductDrawerOpen: false })}
        title={"Add Product"}
        headerHidden={false}
        customWidth={false} >
        <div className='px-4'>
          <CustomSearch
            value={params.query}
            onChange={(e) => setParams((pev) => ({ ...pev, query: e.target.value }))}
          />
          <div className='pt-4 max-h-[80vh]  overflow-y-auto'>
            {productsName.results?.length > 0 && productsName.results?.map((item, index) => {
              return (
                <p key={index} onClick={() => handleSelectedProduct(item)}
                  className='cursor-pointer hover:text-[#0a3021] p-1 ' >{item.productName}</p>
              )
            })}
          </div>

          <div className="flex justify-between items-center">
            <button
              onClick={handleAddProduct}
              className="bg-[#0a3021] text-white px-4 py-2 rounded"
            >
              +Add New
            </button>
          </div>
        </div>
      </SideDrawer>
    </div>
  );
};

export default CrmInvoiceUI;
